"use es6";

export var version = "3.10.8";